if (!customElements.get('dna-collection-gifting')) {
    class DNACollectionGifting extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.revision = 0;
        this.savedRevision = 0;
        this.pending = null;
        this.collect = this.querySelector('[data-dna-collect]');
        this.options = this.querySelector('[data-dna-gift-options]');
        this.wrap = this.querySelector('[data-dna-wrap]');
        this.message = this.querySelector('[data-dna-message]');
        this.status = this.querySelector('[data-dna-status]');
        this.saveButton = this.querySelector('[data-dna-save]');
        if (!this.collect || !this.options || !this.wrap || !this.message) return;
        const stalePreferences = !this.collect.checked && (this.wrap.checked || this.message.value);
        if (this.collect.checked) this.querySelector('details').open = true;
        this.updateEligibility();
        this.addEventListener('input', (event) => {
          if (event.target === this.collect) this.updateEligibility();
          this.revision += 1;
          clearTimeout(this.timer);
          this.showStatus('saving');
          this.timer = setTimeout(() => this.save().catch(() => {}), 350);
        });
        this.saveButton.addEventListener('click', () => this.save().catch(() => {}));
        this.form = this.closest('form');
        this.onSubmit = async (event) => {
          if (this.savedRevision === this.revision && !this.pending) return;
          event.preventDefault();
          event.stopImmediatePropagation();
          try {
            await this.save();
            this.form.requestSubmit(event.submitter || undefined);
          } catch {
            this.querySelector('details').open = true;
            (this.collect.checked ? this.saveButton : this.collect).focus();
          }
        };
        this.form?.addEventListener('submit', this.onSubmit, true);
        if (stalePreferences) {
          this.revision += 1;
          this.save().catch(() => {});
        }
      }
      disconnectedCallback() {
        clearTimeout(this.timer);
        this.form?.removeEventListener('submit', this.onSubmit, true);
      }
      showStatus(key) {
        this.status.textContent = this.dataset[key];
        this.status.toggleAttribute('data-error', key === 'error');
        if (key === 'error') this.saveButton.hidden = false;
      }
      updateEligibility() {
        this.options.hidden = !this.collect.checked;
        this.options.disabled = !this.collect.checked;
        this.saveButton.hidden = !this.collect.checked;
        if (!this.collect.checked) {
          this.wrap.checked = false;
          this.message.value = '';
        }
      }
      save() {
        clearTimeout(this.timer);
        if (this.pending) return this.pending;
        if (this.savedRevision === this.revision) {
          this.showStatus(this.collect.checked ? 'saved' : 'cleared');
          return Promise.resolve();
        }
        this.showStatus('saving');
        this.pending = (async () => {
          while (this.savedRevision !== this.revision) {
            const revision = this.revision;
            const response = await fetch(this.dataset.updateUrl, {
              method: 'POST',
              headers: {'Content-Type': 'application/json', 'Accept': 'application/json'},
              body: JSON.stringify({attributes: {
                'Christmas gift collection': this.collect.checked ? 'Yes' : 'No',
                'Christmas gift wrapping': this.collect.checked && this.wrap.checked ? this.wrap.value : 'No',
                'Gift card message': this.collect.checked ? this.message.value : ''
              }})
            });
            if (!response.ok) throw new Error('Gift preferences could not be saved');
            await response.json();
            this.savedRevision = revision;
          }
          this.showStatus(this.collect.checked ? 'saved' : 'cleared');
        })().catch(error => {
          this.showStatus('error');
          throw error;
        }).finally(() => { this.pending = null; });
        return this.pending;
      }
    }
    customElements.define('dna-collection-gifting', DNACollectionGifting);
  }

  (() => {
    const template = document.getElementById('dna-collection-link-template');
    const styleTemplate = document.getElementById('dna-cart-style-template');
    if (!template && !styleTemplate) return;
    let attached = false;
    const attach = () => {
      if (attached) return;
      const root = document.getElementById('upCart')?.shadowRoot;
      if (!root) return;
      attached = true;
      discovery.disconnect();
      document.removeEventListener('pointerdown', attach);
      const mount = () => {
        if (styleTemplate && !root.getElementById('dna-cart-drawer-style')) root.append(styleTemplate.content.cloneNode(true));
        const footer = root.querySelector('#CartPopup .upcart-footer');
        if (template && footer && !footer.querySelector('.dna-collection-link')) {
          footer.prepend(template.content.cloneNode(true));
        }
      };
      mount();
      new MutationObserver(() => mount()).observe(root, {childList: true, subtree: true});
    };
    const discovery = new MutationObserver(attach);
    discovery.observe(document.body, {childList: true, subtree: true});
    document.addEventListener('pointerdown', attach, {passive: true});
    window.addEventListener('load', attach, {once: true});
    attach();
  })();
